import './style/index.less';
import HighLightText from './HighLightText';

export default HighLightText;
